<template>
  <div class="kuaishou-modify-wrapper">
    <FixedHeader v-model="currentTaskId" @change="onTaskTabChange" @remove="onTaskTabRemove" :before-change="doCurrentFormValidate">
      <FixedItem v-for="task in taskStates" :key="task.id" :data="task">{{ task.id }}</FixedItem>
    </FixedHeader>
    <div class="plans-modify ghost-button-styles" v-if="formData.taskId">
      <!-- 基础信息 -->
      <Moduler title="基础信息" name="basic">
        <BaisicInfos ref="kuaishou-basic" :class="innerPlanModifyForbid"></BaisicInfos>
      </Moduler>

      <!-- 投放目标 -->
      <Moduler title="投放目标" name="basic">
        <AppSettings ref="kuaishou-setting" :class="innerPlanModifyForbid"></AppSettings>
      </Moduler>

      <!-- 搜索快投 -->
      <Moduler title="搜索快投" name="basic">
        <QuickSearch></QuickSearch>
      </Moduler>

      <!-- 用户定向 -->
      <Moduler title="用户定向" name="basic">
        <UserTargetings ref="kuaishou-targeting" :class="outterPlanModifyForbid"></UserTargetings>
      </Moduler>

      <!-- 预算与出价 -->
      <Moduler title="预算与出价" name="basic">
        <Budget ref="kuaishou-budget" :class="outterPlanModifyForbid"></Budget>
      </Moduler>

      <!-- 创意-->
      <Moduler title="创意" name="basic">
        <KsCreatives ref="kuaishou-creative"></KsCreatives>
      </Moduler>
    </div>

    <div class="empty-loading" v-else v-loading="pageLoading"></div>

    <div class="ad-submit">
      <Button @click="doCannel">取消</Button>&ensp;
      <Button type="primary" :loading="submitLoading" @click="submit"> 确认提交 </Button>
    </div>
  </div>
</template>
<script>
import BaisicInfos from './basic.vue'
import AppSettings from './app-settings.vue'
import QuickSearch from './quick-search.vue'
import UserTargetings from './targeting.vue'
import Budget from './budget-bid.vue'
import KsCreatives from './creatives.vue'
import Moduler from '@/components/moduler'
import { FixedHeader, FixedItem } from '@/components/fixed-header/index.js'
import editCommonMethods from '../common/edit.js'

import { getSession } from '@/common/js/api'
import { findPlanTaskById } from '@/api/toutiao.local.model'
import { failedTasksModify } from '@/api/kuaishou.model'
import { addKuaiShouBatchTask } from '@/api/kuaishou.local.model'

const taskIds = getSession('taskIds') || []

export default {
  components: {
    Moduler,
    FixedHeader,
    FixedItem,
    BaisicInfos,
    AppSettings,
    QuickSearch,
    UserTargetings,
    Budget,
    KsCreatives
  },
  computed: {
    // 当外部计划创建成功时，且是在批量失败修改时，禁止对计划参数修改
    outterPlanModifyForbid() {
      const planSucc = this.formData.task_progress >= 5
      return planSucc && this.editState ? 'disable-plan-mask' : ''
    },
    innerPlanModifyForbid() {
      const planSucc = this.formData.task_progress >= 4
      return planSucc && this.editState ? 'disable-plan-mask' : ''
    },
    editState() {
      return this.$route.path.includes('/edit/')
    },
    taskList: {
      get() {
        return this.$store.state.Kuaishou.taskList
      },
      set(list) {
        this.$store.commit('Kuaishou/UPDATE_TASK_LIST', list)
      }
    },
    formData: {
      get() {
        return this.$store.getters['Kuaishou/currTaskParams']
      },
      set(form) {
        this.$store.commit('Kuaishou/UPDATE_CURR_TASK', form)
      }
    },
    taskInfo() {
      return this.$store.state.Kuaishou.taskInfo
    },
    currentTaskId: {
      get() {
        return this.taskInfo.currTaskId
      },
      set(currTaskId) {
        this.$store.commit('Kuaishou/SET_CURR_TASK_INFO', { ...this.taskInfo, currTaskId })
      }
    },
    submitList() {
      return this.$store.getters['Kuaishou/submitParams']
    },
    duplicationState() {
      return this.$route.path.includes('/duplicate/')
    },
    taskStates() {
      return this.taskList.map((task) => task.taskStates)
    }
  },
  data() {
    return {
      formPrefix: 'kuaishou',
      pageLoading: false,
      submitLoading: false
    }
  },
  methods: {
    /**
     * @description: onTaskTabRemove, onTaskTabChange, taskFormValidator, doCurrentFormValidate, doCannel
     * @return {*}
     */
    ...editCommonMethods,

    /**
     * @description: 提交全部任务修改
     */
    submit() {
      const allFilled = this.taskStates.every((s) => s.filled)
      if (!allFilled) {
        return this.$Message.error('请切换任务编号，首次加载数据成功方可复制')
      }

      console.log('this.submitList output: ', this.submitList)

      this.doCurrentFormValidate()
        .then(() => {
          const params = { operation: this.editState ? this.formData.operation : 'enable', planlist: this.submitList }
          ;(this.duplicationState ? addKuaiShouBatchTask(params) : failedTasksModify(params)).then((data) => {
            if (data) {
              this.$Message.success('提交成功， 2秒后自动关闭页面')

              setTimeout(() => {
                window.close()
              }, 2000)
            }
          })
        })
        .catch((e) => {
          console.log('doCurrentFormValidate error output: ', e)
        })
    },

    async getData() {
      this.pageLoading = true

      try {
        const tasks = await findPlanTaskById({ taskIds })
        for (let i = 0; i < tasks.length; i++) {
          const task = tasks[i]

          if (this.duplicationState) {
            task.inner_plan_params.plan_name += '_复制'

            // 批量复制流程，当投放方式为全自动时，清空广告计划id，因为广告计划下只有一条广告
            // 原来的campaign_id不能再用，需要重新选择
            if (task.deliveryMethod === 3) {
              task.campaign_id = ''
            }
          }
        }

        this.pageLoading = false
        this.$store.commit('Kuaishou/SET_MODIFY_PARAMS', tasks || [])
        this.setOperation()
      } catch (e) {}
    },
    setOperation() {
      this.formData = {
        ...this.formData,
        operation: this.editState ? this.formData.operation : 'enable'
      }
    }
  },
  created() {
    this.getData()
    this.currentTaskId = taskIds[0] || 0
  }
}
</script>
<style lang="scss" scoped>
.kuaishou-modify-wrapper {
  height: calc(100vh - 64px);
  overflow: auto;
}
.plans-modify {
  padding: 15px;
}
.empty-loading {
  height: 100vh;
}
.ad-submit {
  position: sticky;
  bottom: 0;
  z-index: 999;
  padding: 16px 24px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="scss">
.disable-plan-mask {
  position: relative;
  z-index: 1;
  .ivu-input {
    z-index: 1;
  }

  &:before {
    width: 100%;
    height: calc(100% + 40px);
    content: ' ';
    position: absolute;
    margin-top: -20px;
    margin-bottom: -20px;
    background-color: rgba(88, 88, 88, 0.04);
    cursor: not-allowed;
    z-index: 2;
  }
}
</style>
